import { Property, PropertyValue } from 'api/clients/PropertyClient'
import { AlmanacFile } from 'types'

export type EditPropertyEventDetails = {
  anchorFile: AlmanacFile
  anchorProperty: Property<PropertyValue> | 'Name'
}
export type EditPropertyEvent = CustomEvent<EditPropertyEventDetails>
export const editPropertyEventName = 'editProperty'
